<!-- A group draws nothing: it only references members that draw themselves. -->
<ng-container *ngIf="!isReferenceGroup()">
<div
  class="dsg-node"
  [ngStyle]="styles()"
  [class.is-selected]="isSelected()"
  [class.is-filter-target]="isFilterTarget()"
  [class.is-drop-target]="isDropTarget()"
  [class.is-locked]="node().locked"
  [class.is-interactive]="interactive()"
  [class.is-file-drag-active]="fileDragActive()"
  [class.is-unbound-data]="isUnboundData()"
  [attr.data-node-id]="node().id"
  [attr.data-node-type]="node().type"
  (pointerdown)="onPointerDown($event)"
  (dblclick)="onDoubleClick($any($event))"
  (dragover)="onFileDragOver($event)"
  (dragleave)="onFileDragLeave($event)"
  (drop)="onFileDrop($event)"
>
  <!-- TEXT — contenteditable only while this node is the one being edited, so
       a stray click never steals focus from the canvas gesture handler. -->
  <!-- A bound text shows its live value; editing reveals the template (the
       value token inside the wording) so the label stays editable. -->
  <div
    *ngIf="node().type === 'TEXT'"
    class="dsg-node-text"
    [dsgFitText]="!isEditingText()"
    [class.is-editing]="isEditingText()"
    [class.is-bound]="!!node().dataBinding || !!node().formula"
    [class.is-initials]="!!node().initialsOfId"
    [class.is-pending]="boundState() === 'loading'"
    [class.is-error]="boundState() === 'error' || formulaResult()?.status === 'error'"
    [attr.title]="boundTitle()"
    [attr.contenteditable]="isEditingText() ? 'true' : null"
    (blur)="onTextBlur($event)"
  ><ng-container *ngIf="!isEditingText() && pendingText() as parts; else plainText">{{ parts.before }}<span class="dsg-text-spinner" role="status" aria-label="Loading"></span>{{ parts.after }}</ng-container><ng-template #plainText>{{ isEditingText() ? node().text?.value : displayText() }}</ng-template></div>

  <!-- IMAGE -->
  <img
    *ngIf="node().type === 'IMAGE' && node().image?.src"
    class="dsg-node-image"
    [src]="node().image!.src"
    [alt]="node().image?.alt || node().name"
    [style.object-fit]="node().image!.fit"
    draggable="false"
  />
  <div class="dsg-node-image-empty" *ngIf="node().type === 'IMAGE' && !node().image?.src">
    <span>No image</span>
  </div>

  <!-- ICON — a Lucide glyph, sized to the node box and styled per node. -->
  <lucide-angular
    *ngIf="node().type === 'ICON' && !hasAction() && node().icon as icon"
    class="dsg-node-icon"
    [img]="$any(iconData())"
    [size]="iconSize()"
    [color]="icon.color"
    [strokeWidth]="icon.strokeWidth"
    [absoluteStrokeWidth]="!!icon.absoluteStrokeWidth"
  ></lucide-angular>

  <button *ngIf="node().type === 'ICON' && hasAction() && node().icon as icon"
    type="button" class="dsg-icon-action" [attr.aria-label]="actionLabel()" [title]="actionLabel()"
    (pointerdown)="$event.stopPropagation()" (click)="activateIcon($event)">
    <lucide-angular [img]="$any(iconData())" [size]="iconSize()" [color]="icon.color"
      [strokeWidth]="icon.strokeWidth" [absoluteStrokeWidth]="!!icon.absoluteStrokeWidth"></lucide-angular>
  </button>

  <!-- WIDGET — delegates to the existing shared DVM component. -->
  <div
    *ngIf="node().type === 'WIDGET' && node().widget"
    class="dsg-node-widget-scale"
    [ngStyle]="widgetScaleStyles()"
  >
    <app-design-widget-host
      [widget]="node().widget!"
      [nodeId]="node().id"
      [title]="node().name"
      [suspended]="suspended()"
      [hideSample]="hideSample()"
    ></app-design-widget-host>
  </div>

  <!-- FRAME / GROUP — recurse. `inFlow` tells each child whether its x/y apply
       or whether the parent's auto-layout positions it. -->
  <app-design-node-view
    *ngFor="let child of children(); trackBy: trackById"
    [node]="child"
    [inFlow]="childrenInFlow()"
    [siblings]="children()"
    [selectedIds]="selectedIds()"
    [dropTargetId]="dropTargetId()"
    [suspended]="suspended()"
    [hideSample]="hideSample()"
    [interactive]="interactive()"
    (iconAction)="iconAction.emit($event)"
    (iconFileDrop)="iconFileDrop.emit($event)"
    [editingTextId]="editingTextId()"
    (nodePointerDown)="onChildPointerDown($event)"
    (nodeDoubleClick)="nodeDoubleClick.emit($event)"
    (textCommit)="textCommit.emit($event)"
  ></app-design-node-view>
</div>
</ng-container>
